// extracted by mini-css-extract-plugin
export default {"pageWrap":"nd-z","fullWidth":"od-z","heading":"pd-z","fullBleed":"qd-z","hidden":"rd-z"};